import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_InertiaLink = _resolveComponent("InertiaLink")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_AclLayout = _resolveComponent("AclLayout")!

  return (_openBlock(), _createBlock(_component_AclLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.users,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "last_name",
                "label-class-name": "weight-regular",
                "class-name": "text-dark",
                label: "Фамилия"
              }),
              _createVNode(_component_el_table_column, {
                prop: "first_name",
                "label-class-name": "weight-regular",
                "class-name": "text-dark",
                label: "Имя"
              }),
              _createVNode(_component_el_table_column, {
                prop: "email",
                "label-class-name": "weight-regular",
                "class-name": "text-dark",
                label: "Эл. почта"
              }),
              _createVNode(_component_el_table_column, {
                label: "",
                width: "250"
              }, {
                default: _withCtx(({ row: { id } }: { row: { id: Number } }) => [
                  _createVNode(_component_InertiaLink, {
                    href: '/acl/users/' + id + '/edit',
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Редактировать")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["href"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}